import { Button, Grid, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/styles";
import { VISA_TYPE_ID } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getChangeSmartTitleByType } from "libs/utils/changeSmart";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setHomeTab,
  setIsChange,
  setSmartFormStep,
  setTypeChange,
} from "redux/modules/uiSlice";
import {
  selectCheckRequestSmartForm,
  smartFormChange,
} from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
    width: 820,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
  wrapCloseIcon: {
    position: "absolute",
    right: 24,
    top: 32,
  },
}));

export default function ChangeSelectPart({ onClose = () => {} }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const { personalID } = useSelector((state) => state.personal.detail);
  const checkRequestSmartFormState = useSelector(selectCheckRequestSmartForm);

  const smartserviceId = get(
    checkRequestSmartFormState,
    "data.smartserviceId",
    ""
  );

  const jumpPartUpdateDataConfig = [
    {
      title: getChangeSmartTitleByType("CO"),
      conditionType: "CO",
      [VISA_TYPE_ID.SMART_T]: SMART_T_STEP.UPDATE_JOB_POSITION,
      [VISA_TYPE_ID.SMART_E]: SMART_T_STEP.UPDATE_JOB_POSITION,
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.UPDATE_JOB_POSITION,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.UPDATE_JOB_POSITION,
    },
    {
      title: getChangeSmartTitleByType("AE"),
      conditionType: "AE",
      [VISA_TYPE_ID.SMART_T]: SMART_T_STEP.ADD_JOB_POSITION,
      [VISA_TYPE_ID.SMART_E]: SMART_T_STEP.ADD_JOB_POSITION,
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.ADD_JOB_POSITION,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.ADD_JOB_POSITION,
    },
    {
      title: getChangeSmartTitleByType("AC"),
      conditionType: "AC",
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.ADD_COMPAMY_INVESTMENT,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.ADD_COMPAMY_INVESTMENT,
    },
    {
      title: getChangeSmartTitleByType("CA"),
      conditionType: "CA",
      [VISA_TYPE_ID.SMART_T]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_E]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.UPDATE_COMPANY_INFO,
    },
    {
      title: getChangeSmartTitleByType("CN"),
      conditionType: "CN",
      [VISA_TYPE_ID.SMART_T]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_E]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.UPDATE_COMPANY_INFO,
    },
    {
      title: getChangeSmartTitleByType("DD"),
      conditionType: "DD",
      [VISA_TYPE_ID.SMART_T]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_E]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_I]: SMART_T_STEP.UPDATE_COMPANY_INFO,
      [VISA_TYPE_ID.SMART_S]: SMART_T_STEP.UPDATE_COMPANY_INFO,
    },
  ];

  const handleClickJumpPart = async (config) => {
    try {
      showLoading();
      await dispatch(smartFormChange({ personalId: personalID }));
    } catch (e) {
      alert(JSON.stringify(e?.message));
    }
    hideLoading();
    onClose();
    dispatch(setIsChange(true));
    dispatch(setTypeChange(config.conditionType));
    dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
    // dispatch(currentDocumentSlice.actions.clearAll());
    dispatch(setSmartFormStep(config[smartserviceId]));
  };

  const byCurrentSmart = (data) => {
    return Object.keys(data).some((v) => v === smartserviceId);
  };

  return (
    <div className={classes.root}>
      <div className={classes.wrapCloseIcon}>
        <IconButton color="inherit" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Typography variant="h6" className={classes.title}>
        SMART VISA QUALIFICATIONS UPDATE FORM
      </Typography>
      <Typography variant="h4" color="secondary">
        Change Smart VISA
      </Typography>
      <Grid container spacing={1} style={{ marginTop: 8 }}>
        <Grid item xs={12} md={12} style={{ marginBottom: 8 }}>
          <Typography variant="h6" className={classes.label}>
            Please select only one
          </Typography>
        </Grid>
        {jumpPartUpdateDataConfig
          .filter(byCurrentSmart)
          .map((config, index) => (
            <Grid item xs={12} md={12} key={index}>
              <Button
                style={{ height: 61 }}
                fullWidth
                variant="outlined"
                onClick={() => handleClickJumpPart(config)}
              >
                {config.title}
              </Button>
            </Grid>
          ))}
      </Grid>
    </div>
  );
}
